import React, { useState, useEffect } from 'react';
import './BomgarUsers.css';
import Header from '../components/Header';
import config from '../config';

const BomgarUsers = () => {
  const [users, setUsers] = useState([]);

  const fetchData = async () => {
    try {
      const response = await fetch(config.api.bomgarUsers);
      const data = await response.json();
      console.log('Fetched data:', data);
      setUsers(data);
    } catch (error) {
      console.error('Error fetching Bomgar users:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleRefresh = () => {
    fetchData();
  };

  return (
    <div className='Header'>
      <Header />
      <div className="bomgar-users-container">
        <div className="refresh-button-container">
          <button className='refresh-button' onClick={handleRefresh}>Refresh</button>
        </div>
        <h1 className="title">Active Bomgar Users</h1>
        <ul className="user-list-container">
          {users.map((user, index) => (
            <li key={index}>{`${user.name}`}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default BomgarUsers;
